import get from 'lodash/get';
import * as regionActions from '../../action_creators/mic/mic2020_regions_action_creators';
import RegionModel from '../../../models/mic/mic2020_region_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchMic2020Regions(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(regionActions.mic2020RegionsLoading());
    return RegionModel.fetch(store)
      .then(function handleRegionData(regionData) {
        dispatch(regionActions.mic2020RegionsLoaded(regionData.data, store));
      })
      .catch(function handleRegionError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(status, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in all region actions, message: ${err.message}`
          );
        }
        dispatch(regionActions.mic2020RegionsLoadError(err, store));
      });
  };
}
